import axios from 'axios'
const TIMEOUT = 3000

const opGatewayInstance = axios.create({
  withCredentials: true,
  baseURL: '/op-gateway',
  headers: {
    'Content-Type': 'application/json',
    'Accept-Language': 'zh-CN,zhq=0.9'
  },
  timeout: 5000 || TIMEOUT
})

export const getJsonRequest = (url) => {
  return axios.get(url).then((data) => {
    if (data && data.status === 200) {
      return data.data
    }
  })
}

export const opPostRequest = (url, data, headers = {}) => {
  return opGatewayInstance({
    method: 'post',
    url,
    data,
    headers: { ...headers }
  })
    .then((data) => {
      if (data && data.status === 200) {
        return data.data
      }
    })
    .catch((err) => {
      return err
    })
}

export const opGetRequest = (url, params, headers = {}) => {
  return opGatewayInstance({
    method: 'get',
    url,
    params,
    headers: { ...headers }
  })
    .then((data) => {
      if (data && data.status === 200) {
        return data.data
      }
    })
    .catch((err) => {
      return err
    })
}
